import {callApi} from './Common';

const APIURL: string = (process.env.REACT_APP_API_URL as string);

/**
 * サービスクラス
 */
class ApiService {

    /**
     * 問い合わせ
     */
    contact = (json:any) => {
        // API実行
        return callApi(APIURL + '/send_mail', "POST", {}, json);
    };
    /**
     * 検索
     */
    search = (json:any) => {
        // API実行
        return callApi(APIURL + '/search', "POST", {}, json);
    }
}
export default ApiService;